var _clipPath, _clipPath2, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoReana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "trac\\xE9s_techniques",
    "data-name": "trac\\xE9s techniques",
    width: 27.114,
    height: 6.214,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs5015"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27566"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#f55",
      fillOpacity: 0.4627451,
      stroke: "none",
      strokeWidth: 1.20000005,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect27568",
    transform: "rotate(-45)",
    d: "M1.903 153.297H12.67v4.352H1.903z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27602"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01333333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m119.05 106.96 5.513-1.472-4.524-3.015-2.937 2.984.066 2.461 2.375 1.43 4.394-1.082.04-1.305z",
    id: "path27604"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27620"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01333333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m119.05 106.96 4.252-1.621-2.208-2.638-2.582.667-1.425 2.557.4 3.209 3.875.565 1.45-1.313.884-1.653z",
    id: "path27622"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27656"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01333333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M123.937 106.833h1.902l-2.35 2.445-4.236-.588.875-5.6 5.375.226-.03 2.95z",
    id: "path27658"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4807"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01183265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m119.05 106.96 4.465-1.764-1.92-1.883-2.58.088-2.143 2.273.078 2.486 3.485 1.082 3.07-1.503-.615-1.446z",
    id: "path4809"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4823"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01333333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m-7.893 9.314.002 5.41 2.02-.728.077-5.937-2.597-1.133z",
    id: "path4825"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4848"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.01183265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m119.05 106.96 4.465-1.764-2.385-2.766-3.079.832-1.03 2.694-.156 2.632 2.38 1.904 2.79-.354 1.363-1.904-.031-1.269z",
    id: "path4850"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5015"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath13500"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style5013"
  }, "\n      .cls-3 {\n        fill: #2d3e51\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(-6.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9431",
    className: "cls-3",
    d: "M34.065 2.265v3.849h-1.852v-.68a2.13 2.13 0 0 1-1.807.769 1.83 1.83 0 0 1-2.03-1.852c0-1.116.803-1.774 2.23-1.785h1.552v-.09c0-.58-.38-.925-1.116-.925a4.228 4.228 0 0 0-1.763.49L28.744.793a6.248 6.248 0 0 1 2.733-.67c1.629 0 2.566.804 2.577 2.143zm-1.863 1.852V3.58h-1.194c-.569 0-.848.201-.848.636s.302.703.826.703a1.194 1.194 0 0 0 1.216-.803z",
    style: {
      fill: "#2d3e51",
      strokeWidth: 1.1156683
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d3e51",
      strokeWidth: 1.13809323
    },
    d: "M28.094 2.312v3.801h-1.912V2.847a1.036 1.036 0 0 0-1.07-1.138 1.24 1.24 0 0 0-1.23 1.218v3.186h-1.934V.093h1.935v.979a2.276 2.276 0 0 1 2.014-1.07 2.117 2.117 0 0 1 2.197 2.276z",
    className: "cls-3",
    id: "path9897"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff3336",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.25067377,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect22907",
    d: "M6.952.161h1.633v6H6.952z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff3336",
      strokeWidth: 1.1640048,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path27554",
    cx: 117.776,
    cy: 106.194,
    rx: 2.112,
    ry: 2.115,
    clipPath: "url(#clipPath27566)",
    transform: "matrix(1.23637 0 0 1.11567 -135.296 -115.354)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#ff3336",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.1640048,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "M120.367 103.482a2.704 2.704 0 0 0-2.695 2.696 2.706 2.706 0 0 0 2.695 2.697 2.704 2.704 0 0 0 2.694-2.697 2.702 2.702 0 0 0-2.694-2.696zm0 1.164c.852 0 1.53.678 1.53 1.532s-.678 1.533-1.53 1.533c-.851 0-1.531-.68-1.531-1.533 0-.854.68-1.532 1.531-1.532z",
    clipPath: "url(#clipPath4848)",
    id: "ellipse27558",
    transform: "matrix(1.12683 0 0 1.12683 -122.368 -116.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect27570",
    style: {
      opacity: 1,
      fill: "#ff3336",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.72761714,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(-111.55 .147 -.02)",
    clipPath: "url(#clipPath4823)",
    d: "M-7.915 8.771h1.254v4.605h-1.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d3e51",
      strokeWidth: 1.1156683
    },
    d: "M21.598 2.263v3.85h-1.852v-.681a2.13 2.13 0 0 1-1.808.77 1.83 1.83 0 0 1-2.03-1.852c0-1.116.803-1.774 2.231-1.785h1.551v-.09c0-.58-.38-.926-1.116-.926a4.228 4.228 0 0 0-1.762.491L16.276.79A6.248 6.248 0 0 1 19.01.122c1.63 0 2.567.804 2.578 2.142zm-1.863 1.852V3.58H18.54c-.57 0-.848.2-.848.636 0 .435.301.703.826.703a1.194 1.194 0 0 0 1.216-.804z",
    className: "cls-3",
    id: "path9863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReana);
export default __webpack_public_path__ + "static/media/logo-reana.24ee94a084d41b15d6f04802a3b01c91.svg";
export { ForwardRef as ReactComponent };